/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import _ from "lodash";
import { nFormatter } from "lib/utils";
import { roiNumerator } from "lib/roi/strategies";
import { useSelector } from "react-redux";
import mixpanelTrack from "app/common/MixpanelComponent";
import { promotionsLegendCategories } from "./utils";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 900,
    margin: "24px auto",
    borderRadius: 8,
    overflow: "hidden",
    background: "transparent",
    boxShadow: "none",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: "inherit",
    background: "transparent",
  },
  th: {
    background: "#181F2B",
    color: "#fff",
    textAlign: "center",
    padding: "14px 0",
    fontWeight: 700,
    fontSize: 16,
    border: "none",
  },
  td: {
    textAlign: "center",
    padding: "14px 0",
    fontWeight: 400,
    fontSize: 15,
    border: "none",
    background: "#fff",
  },
  row: {
    background: "#fff",
  },
  rowAlt: {
    background: "#F6F6F7",
  },
  firstCol: {
    textAlign: "left",
    paddingLeft: 24,
    fontWeight: 700,
    fontSize: 15,
    color: "#444",
    background: "#fff",
    border: "none",
  },
  firstColAlt: {
    textAlign: "left",
    paddingLeft: 24,
    fontWeight: 700,
    fontSize: 15,
    color: "#444",
    background: "#F6F6F7",
    border: "none",
  },
  paper: {
    borderRadius: 8,
    overflow: "hidden",
    boxShadow: "0 2px 8px 0 rgba(0,0,0,0.04)",
    background: "transparent",
  },
}));

/**
 * Espera props:
 * columns: array de strings (nombres de columnas)
 * rows: array de objetos { label: string, values: array de strings }
 */

const PromotionsTotalsTable = ({ datasets }) => {
  const classes = useStyles();
  const {
    features: { newInvestmentCalculation, roiStrategy },
  } = useSelector((state) => state.auth.configCatUser);

  useEffect(() => {
    /* MIXPANEL TRACKS */
    mixpanelTrack("Value destroyers totals table viewed");
    /* END OF MIXPANEL TRACKS */
  }, []);

  const getTotalsTableData = () => {
    return [
      {
        label: "# Promotions",
        values: _.map(promotionsLegendCategories, (promotionCategory) => {
          const dataset = _.find(datasets, { label: promotionCategory.label });
          if (!dataset?.data || dataset.data.length === 0) return 0;
          return Array.from(dataset.data).length || 0;
        }),
      },
      {
        label: "Volume",
        values: _.map(promotionsLegendCategories, (promotionCategory) => {
          const dataset = _.find(datasets, { label: promotionCategory.label });
          if (!dataset?.data || dataset.data.length === 0) return 0;
          return nFormatter(_.sumBy(dataset?.data, (d) => d.sum_units) || 0);
        }),
      },
      {
        label: "Sales Out",
        values: _.map(promotionsLegendCategories, (promotionCategory) => {
          const dataset = _.find(datasets, { label: promotionCategory.label });
          if (!dataset?.data || dataset.data.length === 0) return 0;
          return nFormatter(_.sumBy(dataset?.data, (d) => d.sum_sales) || 0);
        }),
      },
      {
        label: "Margin",
        values: _.map(promotionsLegendCategories, (promotionCategory) => {
          const dataset = _.find(datasets, { label: promotionCategory.label });
          if (!dataset?.data || dataset.data.length === 0) return 0;
          return nFormatter(_.sumBy(dataset?.data, (d) => d.sum_margin) || 0);
        }),
      },
      {
        label: "Investment",
        values: _.map(promotionsLegendCategories, (promotionCategory) => {
          const dataset = _.find(datasets, { label: promotionCategory.label });
          if (!dataset?.data || dataset.data.length === 0) return 0;

          const totalInvestment = _.sumBy(dataset.data, (d) => {
            if (!d.reference) return 0;
            const investment = newInvestmentCalculation
              ? (d.reference.avg_weight_by_units_in_price_in_wo_taxes -
                  d.avg_weight_by_units_in_price_in_wo_taxes) *
                d.sum_units_in
              : (d.reference.avg_weight_by_units_in_price_in -
                  d.avg_weight_by_units_in_price_in) *
                d.sum_units_in;

            return investment || 0;
          });

          return nFormatter(totalInvestment);
        }),
      },
      {
        label: "ROI",
        values: _.map(promotionsLegendCategories, (promotionCategory) => {
          const dataset = _.find(datasets, { label: promotionCategory.label });
          if (!dataset?.data || dataset.data.length === 0) return 0;

          const totalMarginDiff = _.sumBy(dataset.data, (d) =>
            roiNumerator(roiStrategy, {
              marginEsc: d.sum_margin,
              marginRef: d.reference.sum_margin,
              unitsEsc: d.sum_units,
              unitsRef: d.reference.sum_units,
            })
          );

          // Suma total de inversiones usando la misma lógica que formatPromotions
          const totalInvestment = _.sumBy(dataset.data, (d) => {
            if (!d.reference) return 0;
            // Usar la misma lógica de investment que en formatPromotions
            const investment = newInvestmentCalculation
              ? (d.reference.avg_weight_by_units_in_price_in_wo_taxes -
                  d.avg_weight_by_units_in_price_in_wo_taxes) *
                d.sum_units_in
              : (d.reference.avg_weight_by_units_in_price_in -
                  d.avg_weight_by_units_in_price_in) *
                d.sum_units_in;

            return investment || 0;
          });

          // ROI agregado
          const aggregatedROI =
            totalInvestment !== 0
              ? (totalMarginDiff / totalInvestment) * 100
              : 0;

          return `${nFormatter(aggregatedROI)}%`;
        }),
      },
    ];
  };

  return (
    <Paper className={classes.paper} elevation={0}>
      <div className={classes.root}>
        <table className={classes.table}>
          <thead>
            <tr>
              <th
                className={classes.th}
                style={{ borderRadius: "8px 0 0 0" }}
              />
              {promotionsLegendCategories.map((col, idx) => (
                <th
                  key={col.id}
                  className={classes.th}
                  style={
                    idx === promotionsLegendCategories.length - 1
                      ? { borderRadius: "0 8px 0 0" }
                      : undefined
                  }
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {getTotalsTableData().map((row, idx) => (
              <tr
                key={row.label}
                className={idx % 2 === 1 ? classes.rowAlt : classes.row}
              >
                <td
                  className={
                    idx % 2 === 1 ? classes.firstColAlt : classes.firstCol
                  }
                >
                  {row.label}
                </td>
                {row.values.map((val, i) => (
                  <td key={i} className={classes.td}>
                    {val}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Paper>
  );
};

export default PromotionsTotalsTable;
